import { CoreUsersByIdNotificationPreferencesName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getUserNotificationPreferences } from '@api';

export const coreUsersByIdNotificationPreferencesGetAsyncSlice = createGetAsyncSlice({
	name: CoreUsersByIdNotificationPreferencesName,
	receive: true,
	request: true,
	requestHandler: getUserNotificationPreferences
});
